import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_GRAVITY_ANGLE, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { useDispatch } from "react-redux";
import { Range } from "../../../../range/range";
import { Control } from "../../../../control/control";
import { setGravityAngle } from "../../../../../features/config/config.slice";
export const SnowflakeGravityAngle = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Angle", tooltip: "The angle of the force of gravity, in degrees", showOutput: true, reset: () => {
            const angle = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].gravity.angle : DEFAULT_GRAVITY_ANGLE;
            dispatch(setGravityAngle({
                index,
                angle
            }));
        }, value: layer.gravity.angle, onChange: (event) => dispatch(setGravityAngle({
            index,
            angle: Number(event.target.value),
        })), children: _jsx(Range, { min: "0", max: "360", step: "1" }) }));
};
